import { gsap, ScrollTrigger } from '../lib/gsap';

const initPinned = (elements) => {
    elements.forEach(element => {
        ScrollTrigger.create({
            trigger: element,
            start: 'bottom bottom', 
            pin: true, 
            pinSpacing: false 
        });
    })
}

export { initPinned as default };
